import React, { ReactNode } from 'react';
import { TableThemeType } from './Table';

const TableData = ({
  children,
  colSpan,
  style,
  theme = 'dark',
}: {
  children?: ReactNode;
  colSpan?: number;
  style?: any;
  theme?: TableThemeType;
}): JSX.Element => {
  
  return (
    <td
      style={{
        borderTop: '1px solid',
        borderColor: (theme === 'light') ? 'rgba(0,0,0,0.125)' : 'rgba(255,255,255,0.25)',
        paddingLeft: '1rem',
        paddingRight: '1rem',
        ...style,
      }}
      colSpan={colSpan}
    >
      {children}
    </td>
  );
};

export default TableData;
